import React, { useState } from 'react';
import { Layout, Seo } from '@layout';
import { weddingInvitationsPageData as pageData } from '@data-ts/pages/wedding-invitations';
import { graphql } from 'gatsby';
import {
  HighQualityPrintsSection,
  InvitationsReimaginedSection,
  ConnectedGuestListSection,
  SmartRSVPSection,
  EcoSection,
} from '@sections/wedding-invitations';
import { ColoredBlockSection } from '@sections/shared/ColoredBlockSection';
import { faqQuestionsData } from '@data-ts/components/FaqQuestions';
import { FaqList } from '@components/FaqList';
import { AbcSection } from '@sections/shared/AbcSection';
import { GalleryPageContent } from '@components/GalleryComponents/GalleryPageContent/GalleryPageContent';
import { invitationDesignsCanonicalUrl } from '@utils/gallery.util';
import { productTypes } from '@data-ts/components/GalleryComponents/GalleryPageContent';

export const query = graphql`
  {
    bliss {
      themeVariants(variantTypes: [invite]) {
        variationType
        imageUrl
        printUrl
        vendor
        tags
        colors
        font
        variantColor
        variantName
        variantThemeId
        theme {
          id
          name
          themeId
          marketingData {
            variationType
            imageUrl
            printUrl
            vendor
            tags
            colors
            font
            variantColor
            variantName
            variantThemeId
            theme {
              name
              themeId
            }
          }
        }
      }
    }
  }
`;

const page: MarcomPageName = 'wedding-invitations';

const WeddingInvitationsDesigns = ({ data }: { data: BlissGalleryECardsThemesData }) => {
  let cards: MarketingData = data.bliss.themeVariants.filter(v => v.theme);
  const [chromeless, setChromeless] = useState(false);
  return (
    <Layout
      isTransparentHeader={true}
      transparentJoyLogoColor="purple6"
      transparentHeaderButtonVariant="primary"
      transparentHeaderLinkVariant="navLink"
      page={page}
      chromeless={chromeless}
    >
      <Seo
        title={pageData.seo.title}
        description={pageData.seo.content}
        canonicalURL={invitationDesignsCanonicalUrl}
        ogImage={'common/meta_share/invites.jpg'}
      />
      <GalleryPageContent
        page={page}
        productType={productTypes.invitation}
        cards={cards}
        showModal={isModalOpened => {
          setChromeless(isModalOpened);
        }}
      />
      <HighQualityPrintsSection />
      <InvitationsReimaginedSection />
      <SmartRSVPSection />
      <ConnectedGuestListSection />
      <EcoSection />
      <ColoredBlockSection
        isLeftAligned
        backgroundColor="humana1Light"
        sideHeaderText={'Frequently <br/> Asked <br/> Questions'}
        sectionId="Wedding_Invitation_Design_FAQ"
        isToggleNeeded={true}
      >
        <FaqList
          accordion={true}
          questionNodes={[...faqQuestionsData.weddingInvitationDesign, ...faqQuestionsData.general]}
          color="neutra6"
        />
      </ColoredBlockSection>
      <AbcSection page={page} abcSectionId="Wedding_Invitation_Design_ABC_CTA" />
    </Layout>
  );
};

export default WeddingInvitationsDesigns;
